<template>
  <div class="step-bank-intro step-stagger">
    <h1 class="step-heading" dir="auto">אנחנו רוצים להתחייב על החסכון שלך!</h1>
    <p class="step-subtitle" dir="auto">
      לשם כך נצטרך חיבור מאובטח (קריאה בלבד) לבנק שלך - לא ניתן לבצע שום פעולה דרכנו.
    </p>

    <ul class="trust-list">
      <li class="trust-card">
        <div class="trust-body">
          <h3 class="trust-title" dir="auto">בפיקוח הרשות לניירות ערך</h3>
          <p class="trust-text" dir="auto">תחת רשיון נותן שירותי מידע פיננסי</p>
        </div>
        <div class="trust-badge">
          <img class="trust-badge-star" :src="stars.green" alt="" />
          <img class="trust-badge-icon trust-badge-icon--light" :src="icons.assuredWorkload" alt="" />
        </div>
      </li>

      <li class="trust-card">
        <div class="trust-body">
          <h3 class="trust-title" dir="auto">מוסמכים בתקן ISO 27001</h3>
          <p class="trust-text" dir="auto">תקן אבטחת המידע הבינלאומי</p>
        </div>
        <div class="trust-badge">
          <img class="trust-badge-star" :src="stars.dark" alt="" />
          <img class="trust-badge-icon trust-badge-icon--light" :src="icons.encrypted" alt="" />
        </div>
      </li>

      <li class="trust-card">
        <div class="trust-body">
          <h3 class="trust-title" dir="auto">המידע שלך מוצפן ומאובטח</h3>
          <p class="trust-text" dir="auto">תחת פרוטוקולי האבטחה המתקדמים ביותר</p>
        </div>
        <div class="trust-badge">
          <img class="trust-badge-star" :src="stars.white" alt="" />
          <img class="trust-badge-icon trust-badge-icon--dark" :src="icons.lock" alt="" />
        </div>
      </li>
    </ul>

    <div class="cta-area">
      <CtaButton text="לרשימת הבנקים" @click="$emit('next')" />
    </div>
  </div>
</template>

<script>
import CtaButton from './CtaButton.vue';

/* eslint-disable global-require */
const icons = {
  assuredWorkload: require('../assets/lucide-assured-workload.svg'),
  encrypted: require('../assets/lucide-encrypted.svg'),
  lock: require('../assets/lucide-lock.svg'),
};
const stars = {
  green: require('../assets/star13-green.svg'),
  dark: require('../assets/star12-light.svg'),
  white: require('../assets/star14-white.svg'),
};
/* eslint-enable global-require */

export default {
  name: 'StepBankIntro',
  components: { CtaButton },
  data() {
    return { icons, stars };
  },
};
</script>

<style lang="scss" scoped>
.step-bank-intro {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 27px;
}

.step-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 32px;
  line-height: 36px;
  font-weight: 900;
  font-style: normal;
  font-synthesis: none;
  color: #205441;
  text-align: center;
  margin: 0 auto 32px;
  max-width: 300px;

  @media (max-width: 500px) {
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 24px;
  }
}

.step-subtitle {
  font-family: 'SimplerPro', sans-serif;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
  text-align: center;
  margin: 0 auto 48px;
  max-width: 345px;

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 36px;
  }
}

.trust-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.trust-card {
  position: relative;
  background: #ebf5c4;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 17px;
  min-height: 73px;
  padding: 20px 72px 20px 22px;
  display: flex;
  align-items: center;
}

.trust-body {
  flex: 1;
  text-align: right;
}

.trust-title {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #205441;
  margin: 0;
}

.trust-text {
  font-family: 'SimplerPro', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #205441;
  margin: 0;
}

.trust-badge {
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  width: 38px;
  height: 38px;
}

.trust-badge-star {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.trust-badge-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  display: block;

  &--light {
    filter: brightness(0) invert(1);
  }
}

.cta-area {
  margin-top: auto;
  padding-top: 24px;
  padding-bottom: 24px;
}
</style>
